// @app/common/sidebar/duck/index.js
import sidebarReducer from './reducers';
export { default as sidebarOperations } from './operations';
export default sidebarReducer;